<div *ngIf="is_show_loader">
    <div id="loader-container" >
        <div>
            <mat-spinner *ngIf="is_show_loader" ></mat-spinner>
        </div>
    </div>
</div>
